import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer, persistStore, createTransform } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";

import { reducers } from "../reducers";

// const clearStateTransform = createTransform(
//   (inboudState, key) => {
//     return undefined;
//   },
//   (outboudState, key) => outboudState
// );

const rootPersistConfig = {
  key: "root",
  storage,
  blacklist: ['ticketTabControl'],
  // transforms: [clearStateTransform],
  // stateReconciler: (state, persistedState) => {
  //   const newState = {...state};
  //   delete newState.circularProperty;
  //   return newState
  // }
};

const rootReducer = combineReducers(reducers);

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});


export const persistor = persistStore(store);
export default {store, persistor}
